/**
 * @author Leonel Martinez Cota
 * @fileoverview Plugin used for localization and internationalization
 * @see locales JSON files for traslations.
 * @see docs @ https://github.com/kazupon/vue-i18n
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

/**
 * @returns {object} Messages of the selected language. English is by default
 */
function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}
export default new VueI18n({
  // Refer to the fallback language on the .env files
  locale: process.env.VUE_APP_I18N_LOCALE || 'es',
  fallbackLocale: process.env.VUE_APP_I18N_LOCALE || 'es',
  messages: loadLocaleMessages()
})
